import { render, staticRenderFns } from "./LaboratorySurveyItem.vue?vue&type=template&id=4b10e6b6&"
import script from "./LaboratorySurveyItem.vue?vue&type=script&lang=js&"
export * from "./LaboratorySurveyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports